import React__default from 'react';
import { LoaderScreen, Alert } from '@grandvisionhq/common';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { useDispatch, useSelector, statusSuccess, useIntl } from '@grandvisionhq/state';
import { VariantSelectionStep } from '../components/VariantSelectionStep/VariantSelectionStep.js';
import { getSelectedFrame, getLensTypes, getSelectedLensType } from '../../../state/configurator/selectors.js';
import { selectLensType } from '../../../state/configurations/actions.js';

const LensTypeVariantStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const lensTypes = useSelector(getLensTypes);
    const selectedLensType = useSelector(getSelectedLensType);
    const onChange = React__default.useCallback((sku)=>{
        if (!frame) {
            return;
        }
        dispatch(selectLensType({
            frameSku: frame.sku,
            lensTypeSku: sku,
            reason: 'user selection'
        }));
    }, [
        dispatch,
        frame
    ]);
    if (!statusSuccess(lensTypes)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    const variantsList = selectedLensType === null || selectedLensType === void 0 ? void 0 : selectedLensType.variants;
    if (!variantsList || variantsList.length === 0) {
        return /*#__PURE__*/ React__default.createElement(Failed, null);
    }
    return /*#__PURE__*/ React__default.createElement(VariantSelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: variantsList,
        selectedItemSku: selectedLensType === null || selectedLensType === void 0 ? void 0 : selectedLensType.sku
    });
};
function Failed() {
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        title: getLabel('products.glasses.configurator.error'),
        className: "variant-selection-step__alert"
    });
}

export { LensTypeVariantStepContainer };
//# sourceMappingURL=LensTypeVariantStepContainer.js.map
